import React from 'react';
import { Autocomplete, TextField } from '@mui/material';
import PropTypes from 'prop-types';

function FilterAutocomplete(props) {
    const generateKey = (item) => {
        return `${item}_${new Date().getTime()}`;
    };

    return (
        <Autocomplete
            multiple={props.multiple}
            limitTags={5}
            fullWidth
            size="small"
            id={props.id}
            className={props.className}
            value={props.value}
            onChange={props.onChange}
            options={props.options}
            getOptionLabel={props.getOptionLabel}
            renderInput={(params) => (
                <TextField
                    {...params}
                    variant="outlined"
                    label={props.label}
                    placeholder={props.placeholder}
                />
            )}
            renderOption={(optionProps, option) => (
                <li {...optionProps} key={generateKey(option)}>
                    {props.renderOptionContent ? props.renderOptionContent(option) : option}
                </li>
            )}
            isOptionEqualToValue={(option, value) => {
                // Case-insensitive comparison; null-safe for single-select empty (null) values.
                return String(option ?? '').toLowerCase() === String(value ?? '').toLowerCase();
            }}
            filterOptions={(options, { inputValue }) => {
                // Case-insensitive filtering
                const lowerInputValue = inputValue.toLowerCase();
                return options.filter(option => {
                    if (props.customFilter) {
                        return props.customFilter(option, lowerInputValue);
                    }
                    return option.toLowerCase().includes(lowerInputValue);
                });
            }}
        />
    );
}

FilterAutocomplete.propTypes = {
    multiple: PropTypes.bool,
    id: PropTypes.string.isRequired,
    className: PropTypes.string,
    value: PropTypes.any,
    onChange: PropTypes.func.isRequired,
    options: PropTypes.array.isRequired,
    getOptionLabel: PropTypes.func,
    label: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    renderOptionContent: PropTypes.func,
    customFilter: PropTypes.func,
};

FilterAutocomplete.defaultProps = {
    multiple: false,
    getOptionLabel: (option) => option || '',
    placeholder: '',
};

export default FilterAutocomplete;